module.exports = __webpack_public_path__ + "img/L_320_326.937ffd9e.png";